import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { ResponsiveContext, Box, Text, Button, Menu } from 'grommet';
import { Notes, Edit, More, Download, Search, Trash, Copy, Alarm } from 'grommet-icons';

import { EmptySearches, Placeholder, ErrorsSearches, Pagination, Tag } from '../../../../components';
import { Onboarding } from '../onboarding/onboarding';

import { toggleDetailsLayer } from '../../actions/details';
import { generateCsv } from '../../actions/export-csv';
import { openFormSearchLayer, goToNextPage, goToPrevPage } from '../../actions/form-search';
import { toggleFormManagerLayer, copyLayer } from '../../actions/form-manager';
import { toggleFormReminderLayer } from '../../actions/form-reminder';
import { toggleFormDeleteLayer } from '../../actions/form-delete';

import { formattedNumber, formattedCurrency } from '../../../../utils';

import rulesName from '../../../../constants/rules';
import { amendmentResources } from '../../../../constants/amendment-resources';

const SearchResultComponent = (props) => {
  const {
    userLogged: { rules, client },

    loadingFormSearch,
    dataRows,
    totalOfRows,
    getListError,

    reference,
    object,
    beneficiary,
    valueInit,
    valueEnd,
    requester,
    region,
    stageId,
    secretaryId,
    resourceOrigin,
    year,
    page,
    limit,

    toggleDetailsLayer,
    generateCsv,
    toggleFormDeleteLayer,
    toggleFormManagerLayer,
    toggleFormReminderLayer,
    copyLayer,
    openFormSearchLayer,
    goToNextPage,
    goToPrevPage,
  } = props;

  if(loadingFormSearch && !getListError) {
    return (
      <Placeholder
        title='Carregando...'
        message='Aguarde que estamos preparando as coisas :)'
      />
    );
  }

  if(getListError) {
    return <ErrorsSearches
      button={{
        label: 'Abrir filtros',
        action: openFormSearchLayer
      }}
    />;
  }

  if(!dataRows.length && client.trl) {
  //if(dataRows.length && !client.trl) {
    return <Onboarding />;
  }

  if(!dataRows.length) {
    return <EmptySearches
      buttonFilters={{
        label: 'Abrir filtros',
        action: openFormSearchLayer,
      }}

      buttonCreate={
        rules.includes(rulesName.createExpense) ?
          { label: 'Nova emenda', action: toggleFormManagerLayer } : null
      }
    />;
  }

  const optionsMenu = (row) => {
    const options = [];

    if(rules.includes(rulesName.editExpense)) {
      options.push({
        label: (
          <Box pad={{ horizontal: 'small' }} gap='small' direction='row'>
            <Edit />
            <Text size='small'>Editar</Text>
          </Box>
        ),
        onClick: () => toggleFormManagerLayer(row)
      });
    }

    if(rules.includes(rulesName.createExpense)) {
      options.push({
        label: (
          <Box pad={{ horizontal: 'small' }} gap='small' direction='row'>
            <Copy />
            <Text size='small'>Copiar</Text>
          </Box>
        ),
        onClick: () => copyLayer(row)
      });
    }

    options.push({
      label: (
        <Box pad={{ horizontal: 'small' }} gap='small' direction='row'>
          <Alarm />
          <Text size='small'>Criar lembrete</Text>
        </Box>
      ),
      onClick: () => toggleFormReminderLayer(row)
    });

    if(rules.includes(rulesName.deleteExpense)) {
      options.push({
        label: (
          <Box pad={{ horizontal: 'small' }} gap='small' direction='row'>
            <Trash color='status-error' />
            <Text size='small'>Excluir</Text>
          </Box>
        ),
        onClick: () => toggleFormDeleteLayer(row)
      });
    }

    return options;
  }

  return (
    <ResponsiveContext.Consumer>
      {size => {
        return (
          <Box
            direction='row'
            justify='center'
            margin={{ horizontal: 'medium', top: '80px' }}
          >
            <Box
              pad='small'
              width='xlarge'
            >
              <Box
                align='center'
                direction='row'
                justify='between'
                margin={{ bottom: 'small' }}
              >
                <Box
                  direction={size === 'small' ? 'column' : 'row'}
                  align={size === 'small' ? 'baseline' : 'center'}
                  gap={size === 'small' ? null : 'small'}
                >
                  <Text size='xlarge'>{formattedNumber(totalOfRows)}</Text>

                  <Text
                    size={size === 'small' ? 'xsmall' : 'medium'}
                    color='dark-6'
                  >
                    {totalOfRows > 1 ? 'Emendas' : 'Emenda'}
                  </Text>
                </Box>

                <Box direction='row' align='center'>
                  {rules.includes(rulesName.printExpense) &&
                    <Button
                      title={`Download Excel (.csv) das ${formattedNumber(totalOfRows)} emenda(s) encontrada(s)`}
                      icon={<Download />}
                      size='small'
                      margin={{ right: 'xsmall' }}
                      onClick={() => {
                        generateCsv({
                          reference,
                          object,
                          beneficiary,
                          valueInit,
                          valueEnd,
                          requester,
                          region,
                          stageId,
                          secretaryId,
                          resourceOrigin,
                          year,
                          page: 1,
                          limit: totalOfRows,
                        })
                      }}
                    />
                  }

                  <Button
                    title='Filtrar'
                    icon={<Search />}
                    size='small'
                    onClick={() => { openFormSearchLayer() }}
                  />

                  {rules.includes(rulesName.createExpense) &&
                    <Button
                      primary
                      color='neutral-1'
                      size='small'
                      label='Nova'
                      onClick={() => { toggleFormManagerLayer() }}
                      margin={{ left: 'small' }}
                    />
                  }
                </Box>
              </Box>

              <Box
                direction='row'
                pad={{ vertical: 'medium' }}
                border={{ side: 'bottom', color: 'light-5' }}
                gap='small'
              >
                {size !== 'small' && <Box width='10vw'>
                  <Text color='dark-2'>Ano</Text>
                </Box>}

                {size !== 'small' && <Box width='30vw'>
                  <Text color='dark-2'>Recurso</Text>
                </Box>}

                {size !== 'small' && <Box width='40vw'>
                  <Text color='dark-2'>Objeto</Text>
                </Box>}

                {size !== 'small' && <Box width='40vw'>
                  <Text color='dark-2'>Cidade</Text>
                </Box>}

                {size !== 'small' && <Box width='30vw'>
                  <Text color='dark-2'>Valor</Text>
                </Box>}

                {size !== 'small' && size !== 'medium' && (
                  <Box width='30vw'>
                    <Text color='dark-2'>Estágio</Text>
                  </Box>
                )}

                <Box width='20vw' />
              </Box>

              {dataRows.map(row => {
                const menu = optionsMenu(row);

                return (
                  <Box
                    key={row.id}
                    align='center'
                    direction='row'
                    pad={{ vertical: size === 'small' ? 'small' : 'xsmall' }}
                    border={{ side: 'bottom', color: 'light-5' }}
                    gap='small'
                  >
                    {size !== 'small' && <Box width='10vw'>
                      <Text color='dark-2' size='small'>{row.year}</Text>
                    </Box>}

                    {size !== 'small' && <Box width='30vw'>
                      <Text color='dark-2' size='small'>{amendmentResources[row.resourceOrigin]}</Text>
                    </Box>}

                    <Box width='40vw'>
                      <Text color='dark-2' size='small'>{row.object}</Text>
                    </Box>

                    <Box width='40vw'>
                      <Text color='dark-2' size='small'>{row.regionName}</Text>
                    </Box>

                    <Box width='30vw' direction='row'>
                      <Text color='dark-2' size='small'>{formattedCurrency(row.value)}</Text>
                    </Box>

                    {size !== 'small' && size !== 'medium' && (
                      <Box width='30vw' direction='row'>
                        <Tag text={row.stageName} background={row.stageColor} />
                      </Box>
                    )}

                    <Box align='end' width='20vw'>
                      <Box direction='row'>
                        <Button
                          title='Abrir detalhes'
                          icon={<Notes color='dark-3' size='medium' />}
                          onClick={() => { toggleDetailsLayer(row) }}
                        />

                        {menu.length > 0 && (<Menu
                          dropProps={{ align: { right: 'right', top: 'top' } }}
                          icon={<More />}
                          items={menu}
                        />)}
                      </Box>
                    </Box>
                  </Box>
                )
              })}

              <Pagination
                totalOfRows={totalOfRows}
                nextPage={goToNextPage}
                prevPage={goToPrevPage}
                filters={{
                  reference,
                  object,
                  beneficiary,
                  valueInit,
                  valueEnd,
                  requester,
                  region,
                  stageId,
                  secretaryId,
                  resourceOrigin,
                  year,
                  page,
                  limit,
                }}
              />
            </Box>
          </Box>
        )
      }}
    </ResponsiveContext.Consumer>
  )
}

const mapStateToProps = ({ authReducer: { authenticated }, amendmentReducer: { searchResult, formSearch } }) => ({
  userLogged: authenticated,

  reference: formSearch.reference,
  object: formSearch.object,
  beneficiary: formSearch.beneficiary,
  valueInit: formSearch.valueInit,
  valueEnd: formSearch.valueEnd,
  requester: formSearch.requester,
  region: formSearch.region,
  stageId: formSearch.stageId,
  secretaryId: formSearch.secretaryId,
  resourceOrigin: formSearch.resourceOrigin,
  year: formSearch.year,
  page: formSearch.page,
  limit: formSearch.limit,

  loadingFormSearch: searchResult.loadingFormSearch,
  dataRows: searchResult.dataRows,
  totalOfRows: searchResult.totalOfRows,
  getListError: searchResult.getListError,
});

const mapDispatchToProps = dispath => {
  return bindActionCreators({
    toggleDetailsLayer,
    generateCsv,
    toggleFormDeleteLayer,
    toggleFormManagerLayer,
    toggleFormReminderLayer,
    copyLayer,
    openFormSearchLayer,
    goToNextPage,
    goToPrevPage,
  }, dispath)
};

export const SearchResult = connect(mapStateToProps, mapDispatchToProps)(SearchResultComponent);
